// Weboz Nexus AI & Cloud - Interactive Controller (Fully Responsive & Mobile Optimized)
document.addEventListener('DOMContentLoaded', () => {
  // Sticky Header Blur effect
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 30) {
      header?.classList.add('scrolled');
    } else {
      header?.classList.remove('scrolled');
    }
  });

  // Mobile Navigation Drawer Toggle & Close
  const mobileToggleBtn = document.getElementById('mobile-toggle-btn');
  const mobileDrawer = document.getElementById('mobile-nav-drawer');
  const mobileOverlay = document.getElementById('mobile-drawer-overlay');
  const mobileCloseBtn = document.getElementById('mobile-drawer-close-btn');
  const mobileLinks = document.querySelectorAll('.mobile-nav-link');

  function openMobileMenu() {
    mobileDrawer?.classList.add('open');
    mobileOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileDrawer?.classList.remove('open');
    mobileOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  mobileToggleBtn?.addEventListener('click', openMobileMenu);
  mobileCloseBtn?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  mobileLinks.forEach(link => {
    link.addEventListener('click', closeMobileMenu);
  });

  // Portfolio Filter Tabs with Smooth Animation
  const filterTabs = document.querySelectorAll('.filter-tab');
  const portfolioCards = document.querySelectorAll('.portfolio-card-wrap');
  
  filterTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      filterTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const cat = tab.getAttribute('data-filter');
      
      portfolioCards.forEach(card => {
        const itemCat = card.getAttribute('data-category') || '';
        if (cat === 'all' || itemCat.includes(cat)) {
          card.style.display = 'block';
          setTimeout(() => { card.style.opacity = '1'; card.style.transform = 'scale(1)'; }, 30);
        } else {
          card.style.opacity = '0';
          card.style.transform = 'scale(0.96)';
          setTimeout(() => { card.style.display = 'none'; }, 200);
        }
      });
    });
  });

  // ROI Calculator
  const trafficSlider = document.getElementById('calc-traffic');
  const aovSlider = document.getElementById('calc-aov');
  const convSlider = document.getElementById('calc-conv');
  
  const trafficDisplay = document.getElementById('traffic-val');
  const aovDisplay = document.getElementById('aov-val');
  const convDisplay = document.getElementById('conv-val');
  
  const totalLiftEl = document.getElementById('calc-total-lift');
  const monthlyLiftEl = document.getElementById('calc-monthly-lift');
  const convBoostEl = document.getElementById('calc-conv-boost');
  
  function calculateROI() {
    if (!trafficSlider || !aovSlider || !convSlider) return;
    
    const traffic = parseInt(trafficSlider.value, 10);
    const aov = parseInt(aovSlider.value, 10);
    const conv = parseFloat(convSlider.value);
    
    if (trafficDisplay) trafficDisplay.textContent = Number(traffic).toLocaleString() + ' visits';
    if (aovDisplay) aovDisplay.textContent = '$' + aov;
    if (convDisplay) convDisplay.textContent = conv.toFixed(1) + '%';
    
    const baseMonthlyRevenue = traffic * (conv / 100) * aov;
    const aiLiftRate = 0.35; // +35% AI & Cloud Speed lift average
    const monthlyLift = baseMonthlyRevenue * aiLiftRate;
    const annualLift = monthlyLift * 12;
    const newConv = conv * 1.35;
    
    if (totalLiftEl) totalLiftEl.textContent = '+$' + Math.round(annualLift).toLocaleString();
    if (monthlyLiftEl) monthlyLiftEl.textContent = '+$' + Math.round(monthlyLift).toLocaleString() + '/mo';
    if (convBoostEl) convBoostEl.textContent = `+${(newConv - conv).toFixed(2)}% (${newConv.toFixed(2)}%)`;
  }
  
  trafficSlider?.addEventListener('input', calculateROI);
  aovSlider?.addEventListener('input', calculateROI);
  convSlider?.addEventListener('input', calculateROI);
  calculateROI();

  // Pricing Annual/Monthly Switcher
  const billingToggle = document.getElementById('billing-toggle');
  const switchMonthly = document.querySelector('.switch-monthly');
  const switchAnnual = document.querySelector('.switch-annual');
  const togglePill = document.querySelector('.toggle-pill');
  const priceAmounts = document.querySelectorAll('.plan-price-amount');
  
  function setBilling(isAnnual) {
    if (isAnnual) {
      togglePill?.classList.add('annual');
      switchAnnual?.classList.add('active');
      switchMonthly?.classList.remove('active');
      
      priceAmounts.forEach(el => {
        const monthly = parseInt(el.getAttribute('data-monthly'), 10);
        const annualMonthly = Math.round(monthly * 0.8);
        el.textContent = annualMonthly.toLocaleString();
      });
    } else {
      togglePill?.classList.remove('annual');
      switchMonthly?.classList.add('active');
      switchAnnual?.classList.remove('active');
      
      priceAmounts.forEach(el => {
        const monthly = parseInt(el.getAttribute('data-monthly'), 10);
        el.textContent = monthly.toLocaleString();
      });
    }
  }
  
  switchMonthly?.addEventListener('click', () => setBilling(false));
  switchAnnual?.addEventListener('click', () => setBilling(true));
  togglePill?.addEventListener('click', () => {
    const isCurrentlyAnnual = togglePill.classList.contains('annual');
    setBilling(!isCurrentlyAnnual);
  });

  // Interactive FAQ Accordion
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    question?.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      faqItems.forEach(i => i.classList.remove('active'));
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // Audit Lead Modal
  const openAuditButtons = document.querySelectorAll('.open-audit-modal');
  const auditModal = document.getElementById('audit-modal');
  const closeAuditBtn = auditModal?.querySelector('.modal-close');
  
  openAuditButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      auditModal?.classList.add('open');
      closeMobileMenu();
    });
  });
  
  closeAuditBtn?.addEventListener('click', () => {
    auditModal?.classList.remove('open');
  });
  
  auditModal?.addEventListener('click', (e) => {
    if (e.target === auditModal) {
      auditModal.classList.remove('open');
    }
  });

  // Cart Drawer
  const cartToggleBtn = document.querySelector('.header-cart-btn');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartCloseBtn = document.querySelector('.cart-drawer-close');

  cartToggleBtn?.addEventListener('click', () => {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
  });

  cartCloseBtn?.addEventListener('click', () => {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
  });

  cartOverlay?.addEventListener('click', () => {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
  });

  // Hero AI Simulator Prompt Ticker
  const aiPromptText = document.getElementById('hero-ai-prompt-text');
  const prompts = [
    'Analyzing checkout drop-off rate for Macarooz Shopify Plus...',
    'Deploying sub-second Cloudflare Workers for Sistaco...',
    'Optimizing auto-ship subscription funnels for The Farmer\'s Juice...',
    'Vector search indexing 50,000+ SKUs for Guardian Baseball...',
    'Real-time yield simulator recalculation for Sumer Money DeFi...',
    'Zero-downtime serverless load test at 10,000 req/sec...'
  ];
  let promptIdx = 0;
  
  if (aiPromptText) {
    setInterval(() => {
      promptIdx = (promptIdx + 1) % prompts.length;
      aiPromptText.style.opacity = '0';
      setTimeout(() => {
        aiPromptText.textContent = prompts[promptIdx];
        aiPromptText.style.opacity = '1';
      }, 300);
    }, 4000);
  }
});

  // ==========================================================================
  // GoEight11 Interactive Hover-to-Reveal Showcase & Scroll Reveal
  // ==========================================================================
  function initEight11Interactions() {
    const serviceRows = document.querySelectorAll('.eight11-service-row');
    const previewImg = document.getElementById('eight11-interactive-img');
    const previewTitle = document.getElementById('eight11-preview-title');
    const previewDesc = document.getElementById('eight11-preview-desc');

    if (serviceRows.length && previewImg) {
      serviceRows.forEach(row => {
        row.addEventListener('mouseenter', function() {
          serviceRows.forEach(r => r.classList.remove('active'));
          this.classList.add('active');

          const newImg = this.getAttribute('data-preview-img');
          const newTitle = this.getAttribute('data-title');
          const newDesc = this.getAttribute('data-desc');

          previewImg.style.opacity = '0.3';
          previewImg.style.transform = 'scale(0.96)';

          setTimeout(() => {
            if (newImg) previewImg.src = newImg;
            if (newTitle && previewTitle) previewTitle.textContent = newTitle;
            if (newDesc && previewDesc) previewDesc.textContent = newDesc;
            previewImg.style.opacity = '1';
            previewImg.style.transform = 'scale(1)';
          }, 180);
        });
      });
    }

    // Scroll Reveal Observer (AOS style)
    const revealElements = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && revealElements.length) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      revealElements.forEach(el => revealObserver.observe(el));
    } else {
      revealElements.forEach(el => el.classList.add('is-revealed'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEight11Interactions);
  } else {
    initEight11Interactions();
  }


  // Mobile Navigation Drawer Toggle Handler
  function initMobileDrawer() {
    var openBtn = document.getElementById('mobile-menu-open-btn');
    var closeBtn = document.getElementById('mobile-drawer-close-btn');
    var drawer = document.getElementById('mobile-drawer');
    var overlay = document.getElementById('mobile-drawer-overlay');
    var links = document.querySelectorAll('.mobile-nav-link');

    function openDrawer() {
      if (drawer) drawer.classList.add('active');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (drawer) drawer.classList.remove('active');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    links.forEach(function(l) { l.addEventListener('click', closeDrawer); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileDrawer);
  } else {
    initMobileDrawer();
  }
